function contextFieldsFromDraft(draft, typeFlow) {
	return {
		category: draft?.category || null,
		subCategory: draft?.subCategory || null,
		selectedPlan: draft?.selectedPlan || null,
		highestLevel: draft?.highestLevel || null,
		typeFlowJourney: typeFlow || null,
	}
}

export function normalizeString(value) {
	const trimmed = String(value || '').trim()
	return trimmed || null
}

export function normalizeList(value) {
	if (!Array.isArray(value)) return []
	return value.map(item => String(item || '').trim()).filter(Boolean)
}

/**
 * Build journey API payload for a finder selection (CREATE or PATCH).
 */
export function buildJourneySelectionPayload(
	finder,
	{
		draft,
		typeFlow,
		activeJourneyId,
		existingJourney = null,
		nextCareer = '',
		nextCareers = [],
		nextCountry = '',
		nextCountries = [],
		nextCourse = '',
		nextCourses = [],
		isSelectedCareer = false,
	},
) {
	const context = contextFieldsFromDraft(draft, typeFlow)
	const careers = normalizeList(nextCareers)
	const countries = normalizeList(nextCountries)
	const courses = normalizeList(nextCourses)
	const career = normalizeString(nextCareer)
	const country = normalizeString(nextCountry)
	const course = normalizeString(nextCourse)

	const existingCareers = normalizeList(existingJourney?.careers)
	const existingCourses = normalizeList(existingJourney?.courses)

	if (!activeJourneyId) {
		const payload = { ...context }

		if (finder === 'career') {
			payload.career = career
			payload.careers = careers.length ? careers : career ? [career] : []
			payload.country = normalizeString(draft?.country)
			payload.countries = countries
			payload.course = normalizeString(draft?.course)
			payload.courses = courses
			return payload
		}

		if (finder === 'country') {
			payload.career = normalizeString(draft?.career)
			payload.careers = isSelectedCareer ? careers : []
			payload.country = country
			payload.countries = countries.length ? countries : country ? [country] : []
			payload.course = normalizeString(draft?.course)
			payload.courses = courses
			return payload
		}

		if (finder === 'course') {
			payload.career = normalizeString(draft?.career)
			payload.careers = isSelectedCareer ? careers : existingCareers
			payload.country = normalizeString(draft?.country)
			payload.countries = countries.length ? countries : normalizeList(draft?.countries)
			payload.course = course
			payload.courses = courses.length ? courses : course ? [course] : []
			return payload
		}

		return payload
	}

	const payload = { ...context }

	if (finder === 'career') {
		if (existingCareers.length > 0) {
			payload.career = career
			payload.careers = careers
		} else if (career) {
			payload.career = career
			payload.careers = careers.length ? careers : [career]
		}
	}

	if (finder === 'country') {
		payload.country = country
		payload.countries = countries
		if (career) {
			payload.career = career
		}
		if (existingCareers.length > 0 || (isSelectedCareer && careers.length)) {
			payload.careers = careers
		}
	}

	if (finder === 'course') {
		if (existingCourses.length > 0) {
			payload.course = course
			payload.courses = courses
		} else if (course) {
			payload.course = course
			payload.courses = courses.length ? courses : [course]
		}
	}

	return payload
}

export function shouldCreateJourney({ activeJourneyId, pendingMainCardJourney }) {
	return !activeJourneyId && pendingMainCardJourney === true
}

export function shouldPatchJourney({ activeJourneyId }) {
	return Boolean(activeJourneyId)
}
